import { z } from "zod";

export const HistoryBaseSchema = z.object({
  diametre: z.number().int().positive("Le diamètre doit être un nombre positif").nullable().optional(),
  coord: z.string().nullable().optional(),
  code_site: z.string().max(255, "Le code site ne peut pas dépasser 255 caractères").nullable().optional(),
  num_sujet: z.string().max(255, "Le numéro de sujet ne peut pas dépasser 255 caractères").nullable().optional(),
  critere: z.any().nullable().optional(), // JSON field
  implantation: z.string().max(255, "L'implantation ne peut pas dépasser 255 caractères").nullable().optional(),
  implantation_other: z.string().max(255, "L'implantation autre ne peut pas dépasser 255 caractères").nullable().optional(),
  domaine: z.string().max(255, "Le domaine ne peut pas dépasser 255 caractères").nullable().optional(),
  nuisance: z.any().nullable().optional(), // JSON field
  proximite: z.any().nullable().optional(), // JSON field
  taux_freq: z.string().max(255, "Le taux de fréquence ne peut pas dépasser 255 caractères").nullable().optional(),
  type_passage: z.any().nullable().optional(), // JSON field
  accessibilite: z.string().max(255, "L'accessibilité ne peut pas dépasser 255 caractères").nullable().optional(),
  abattage: z.string().max(255, "L'abattage ne peut pas dépasser 255 caractères").nullable().optional(),
  travaux_collet: z.string().max(255, "Les travaux collet ne peuvent pas dépasser 255 caractères").nullable().optional(),
  travaux_tronc: z.string().max(255, "Les travaux tronc ne peuvent pas dépasser 255 caractères").nullable().optional(),
  travaux_houppier: z.string().max(255, "Les travaux houppier ne peuvent pas dépasser 255 caractères").nullable().optional(),
  date_travaux: z.string().max(255, "La date des travaux ne peut pas dépasser 255 caractères").nullable().optional(),
  date_pro_visite: z.string().max(255, "La date de prochaine visite ne peut pas dépasser 255 caractères").nullable().optional(),
  com_pro_visite: z.string().nullable().optional(),
  caract_pied: z.any().nullable().optional(), // JSON field
  caract_tronc: z.string().max(255, "Les caractéristiques du tronc ne peuvent pas dépasser 255 caractères").nullable().optional(),
  hauteur: z.number().int().positive("La hauteur doit être un nombre positif").nullable().optional(),
  port_arbre: z.string().max(255, "Le port de l'arbre ne peut pas dépasser 255 caractères").nullable().optional(),
  stade_dev: z.string().max(255, "Le stade de développement ne peut pas dépasser 255 caractères").nullable().optional(),
  etat_san_collet: z.any().nullable().optional(), // JSON field
  etat_san_tronc: z.any().nullable().optional(), // JSON field
  etat_san_houppier: z.any().nullable().optional(), // JSON field
  address: z.string().max(255, "L'adresse ne peut pas dépasser 255 caractères").nullable().optional(),
  com_access: z.string().nullable().optional(),
  dict: z.any().nullable().optional(), // JSON field
  risque: z.any().nullable().optional(), // JSON field
  proximite_other: z.string().nullable().optional(),
  accessibilite_other: z.string().nullable().optional(),
  caract_pied_other: z.string().nullable().optional(),
  caract_tronc_multiples: z.number().int().nullable().optional(),
  etat_san_collet_cavite: z.number().int().nullable().optional(),
  etat_san_collet_champignons: z.any().nullable().optional(), // JSON field
  etat_san_tronc_cavite: z.number().int().nullable().optional(),
  etat_san_tronc_corps_etranger: z.string().max(255).nullable().optional(),
  etat_san_tronc_champignons: z.any().nullable().optional(), // JSON field
  etat_san_tronc_nuisibles: z.any().nullable().optional(), // JSON field
  etat_san_houppier_champignons: z.any().nullable().optional(), // JSON field
  etat_san_houppier_nuisibles: z.any().nullable().optional(), // JSON field
  risque_general: z.any().nullable().optional(), // JSON field
  travaux_commentaire: z.string().nullable().optional(),
  critere_other: z.string().nullable().optional(),
  risque_general_other: z.string().nullable().optional(),
  type_passage_other: z.string().nullable().optional(),
  type_intervention: z.string().max(255).nullable().optional(),
  etat_san_general: z.any().nullable().optional(), // JSON field
  user_edited_date_travaux: z.date().nullable().optional(),
  travaux_tronc_other: z.string().nullable().optional(),
  travaux_collet_other: z.string().nullable().optional(),
  travaux_houppier_other: z.string().max(2000).nullable().optional(),
  proximite_with_dict: z.any().nullable().optional(), // JSON field
  ville: z.string().max(155).nullable().optional(),
  pays: z.string().max(255).nullable().optional(),
  travaux_tronc_protection: z.string().max(100).nullable().optional(),
  img1: z.string().max(255).nullable().optional(),
  img2: z.string().max(255).nullable().optional(),
  img3: z.string().max(255).nullable().optional(),
  etat_san_tronc_nuisibles_autres: z.string().max(150).nullable().optional(),
  etat_san_houppier_nuisibles_autres: z.string().max(150).nullable().optional(),
  travaux_collet_multiple: z.any().nullable().optional(), // JSON field
  travaux_tronc_multiple: z.any().nullable().optional(), // JSON field
  travaux_houppier_multiple: z.any().nullable().optional(), // JSON field
  status_travaux: z.boolean().default(true).optional(),
  etat_san_collet_champignons_autres: z.string().max(255).nullable().optional(),
  etat_san_tronc_champignons_autres: z.string().max(255).nullable().optional(),
  etat_san_houppier_champignons_autres: z.string().max(255).nullable().optional(),
  etat_san_collet_other: z.string().max(255).nullable().optional(),
  etat_san_tronc_other: z.string().nullable().optional(),
  etat_san_houppier_other: z.string().nullable().optional(),
  etat_san_general_other: z.string().max(200).nullable().optional(),
  user_edited_date_pro_visite: z.date().nullable().optional(),
  espece_id: z.number().int().positive("L'ID de l'espèce doit être un nombre positif"),
  inventaire_id: z.number().int().positive("L'ID de l'inventaire doit être un nombre positif").nullable().optional(),
});

const HistoryDocSchema = z.object({
  id: z.number().int().positive(),
  path: z.string().nullable(),
});

export const HistorySchema = HistoryBaseSchema.extend({
  id: z.number().int().positive(),
  created_at: z.date().nullable().optional(),
  updated_at: z.date().nullable().optional(),
  history_docs: z.array(HistoryDocSchema).optional(),
});

export const HistoryCreateSchema = HistoryBaseSchema.pick({
  diametre: true,
  coord: true,
  code_site: true,
  num_sujet: true,
  critere: true,
  implantation: true,
  domaine: true,
  nuisance: true,
  proximite: true,
  taux_freq: true,
  type_passage: true,
  accessibilite: true,
  abattage: true,
  travaux_collet: true,
  travaux_tronc: true,
  travaux_houppier: true,
  date_travaux: true,
  date_pro_visite: true,
  com_pro_visite: true,
  caract_pied: true,
  caract_tronc: true,
  hauteur: true,
  port_arbre: true,
  stade_dev: true,
  etat_san_collet: true,
  etat_san_tronc: true,
  etat_san_houppier: true,
  address: true,
  com_access: true,
  dict: true,
  risque: true,
  ville: true,
  pays: true,
  status_travaux: true,
  espece_id: true,
  inventaire_id: true,
  img1: true,
  img2: true,
  img3: true,
  travaux_collet_multiple: true,
  travaux_tronc_multiple: true,
  travaux_houppier_multiple: true,
  travaux_collet_other: true,
  travaux_tronc_other: true,
  travaux_houppier_other: true,
  travaux_commentaire: true,
  user_edited_date_travaux: true,
  user_edited_date_pro_visite: true,
});

export const HistoryUpdateSchema = z.object({
  id: z.number().int().positive(),
  diametre: z.number().int().positive("Le diamètre doit être un nombre positif").nullable().optional(),
  coord: z.string().nullable().optional(),
  code_site: z.string().max(255).nullable().optional(),
  num_sujet: z.string().max(255).nullable().optional(),
  address: z.string().max(255).nullable().optional(),
  ville: z.string().max(155).nullable().optional(),
  pays: z.string().max(255).nullable().optional(),
  espece_id: z.number().int().positive("L'ID de l'espèce doit être un nombre positif").optional(),
  inventaire_id: z.number().int().positive("L'ID de l'inventaire doit être un nombre positif").nullable().optional(),
  status_travaux: z.boolean().optional(),
});

export const HistoryListResponseSchema = z.object({
  data: z.array(HistorySchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});

export const HistoryResponseSchema = z.object({
  data: HistorySchema,
  message: z.string().optional(),
});

export const HistorySelectSchema = z.object({
  id: z.number().int().positive().optional(),
  espece_id: z.number().int().positive().optional(),
  inventaire_id: z.number().int().positive().optional(),
  code_site: z.string().optional(),
  num_sujet: z.string().optional(),
  ville: z.string().optional(),
  pays: z.string().optional(),
  status_travaux: z.boolean().optional(),
});

export type HistoryDoc = z.infer<typeof HistoryDocSchema>;
export type History = z.infer<typeof HistorySchema>;
export type HistoryCreateInput = z.infer<typeof HistoryCreateSchema>;
export type HistoryUpdateInput = z.infer<typeof HistoryUpdateSchema>;
export type HistorySelectInput = z.infer<typeof HistorySelectSchema>;

// Form-specific types for frontend
export type HistoryFormData = Omit<HistoryCreateInput, 'status_travaux'> & {
  status_travaux?: boolean;
};

export type HistoryEditFormData = Omit<HistoryUpdateInput, 'id'>;

// Utility types for different UI states
export type HistoryDisplayItem = Pick<History, 'id' | 'code_site' | 'num_sujet' | 'address' | 'ville' | 'status_travaux'>;
export type HistorySelectOption = Pick<History, 'id' | 'code_site' | 'num_sujet'>;
export type HistoryTableItem = Pick<History, 'id' | 'code_site' | 'num_sujet' | 'address' | 'ville' | 'pays' | 'status_travaux' | 'created_at' | 'updated_at'>;

export type HistoryResponse = z.infer<typeof HistoryResponseSchema>;
export type HistoryListResponse = z.infer<typeof HistoryListResponseSchema>;

export const validateHistoryCreate = (data: unknown) => {
  return HistoryCreateSchema.safeParse(data);
};

export const validateHistoryUpdate = (data: unknown) => {
  return HistoryUpdateSchema.omit({ id: true }).safeParse(data);
};

export const validateHistorySelect = (data: unknown) => {
  return HistorySelectSchema.safeParse(data);
};
